const template = `
  mutation PaymentBindCard($prime: String!, $source: String) {
    paymentBindCard(prime: $prime, source: $source)
  }
`

export default async function cardCreate(prime, source) {
  await request(template, { prime, source })
}
